'use client';

import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '@/constants/common';

import * as S from './NotFoundView.styles';

const Header = dynamic(
  () => import('@/components/Header/Header').then(mod => mod.Header),
  { ssr: false }
);

const { HOME } = ROUTES;

export const NotFoundView = () => {
  const { t } = useTranslation();

  return (
    <>
      <S.HeaderWrapper>
        <Header
          showSearch={false}
          showParticipantTabs={false}
          showTopBanner={false}
        />
      </S.HeaderWrapper>
      <S.ContentWrapper>
        <S.Title>404</S.Title>
        <S.Text>{t('NotFound.text')}</S.Text>
        <S.GoHomeLink href={HOME} $variant="primary" $size="m">
          {t('NotFound.button_text')}
        </S.GoHomeLink>
      </S.ContentWrapper>
      <S.Waves />
    </>
  );
};
